import { configureStore } from '@reduxjs/toolkit';
import favoritesReducer from './features/favorites/FavoritesSlices';

const store = configureStore({
  reducer: {
    favorites: favoritesReducer,
  }
});

// Sauvegarde dans le localStorage à chaque modification des favoris
store.subscribe(() => {
  const state = store.getState();
  localStorage.setItem("favorites", JSON.stringify(state.favorites.items));
});

export default store;
